export interface ServiceUnavailableViewModel {
  title: string;
  guidanceBeforeLink: string;
  onlineLinkText: string;
  onlineLinkHref: string;
  guidanceBetweenLinks: string;
  phoneLinkText: string;
  phoneLinkHref: string;
  guidanceAfterLinks: string;
  answersRecoveryGuidance?: string;
  emergencyBeforeLink: string;
  emergencyLinkText: string;
  emergencyLinkHref: string;
  emergencyAfterLink: string;
}

export const serviceUnavailableViewModel: ServiceUnavailableViewModel = {
  title: 'Sorry, this service is unavailable',
  guidanceBeforeLink: 'Use ',
  onlineLinkText: '111 online',
  onlineLinkHref: 'https://111.nhs.uk/',
  guidanceBetweenLinks: ' or call ',
  phoneLinkText: '111',
  phoneLinkHref: 'tel:111',
  guidanceAfterLinks: '.',
  emergencyBeforeLink: 'In case of emergency, call ',
  emergencyLinkText: '999',
  emergencyLinkHref: 'tel:999',
  emergencyAfterLink: ' immediately.',
};

export const serviceUnavailableAfterRetryViewModel: ServiceUnavailableViewModel = {
  ...serviceUnavailableViewModel,
  guidanceAfterLinks: ' or come back later.',
  answersRecoveryGuidance: 'We have not saved your answers. If you come back later when the service is available, you will have to start again.',
};
